import { fetchCampaigns } from '../helpers/api'
import { orderBy } from 'lodash'

const widthScreen = screen.width
const limitItemsInGrid = 6
console.log('width:', widthScreen)
export async function populateCampaigns () {

  const campaigns = await fetchCampaigns()
  const campForBlock = orderBy(campaigns, 'home_block')
  let itemsInGrid = 0
  
  for (const block of campForBlock) {
    if (itemsInGrid < limitItemsInGrid) {createBlockinMobile(block)}
    createBlock(block)
    itemsInGrid++
  }
}

function createBlock (_block) {
  const body = document.getElementById('campaigns-body')
  const container = document.createElement('div')
  const block = document.createElement('a')
  const text = document.createElement('p')
  const img = document.createElement('img')
  const dashedName = _block.home_block.replace('_', '-')

  container.id = `campaign-${dashedName.replace('block', 'column')}`
  container.classList.add('campaign-column')
  block.id = `camp-${dashedName}`
  block.href = _block.campaign_url
  block.classList.add('camp-block')
  if (_block.main_image) img.src = _block.main_image
  img.classList.add('camp-block-img')
  img.alt = _block.name
  text.classList.add('name')
  text.innerText = _block.name

  block.appendChild(img)
  block.appendChild(text)
  container.appendChild(block)
  body.appendChild(container)
}


function createBlockinMobile (_block) {
  const body = document.getElementById('campaigns-body-mobile')
  const container = document.createElement('div')
  const block = document.createElement('a')
  const text = document.createElement('p')
  const img = document.createElement('img')
  const dashedName = _block.home_block.replace('_', '-')

  container.id = `campaign-block-container`
  container.classList.add('campaign-column')
  block.id = `camp-${dashedName}`
  block.href = _block.campaign_url
  block.classList.add('camp-block')
  if (_block.main_image) {img.src = _block.main_image}
  else img.src = 'https://i0.wp.com/www.aulapt.org/wp-content/uploads/2022/03/google-imagenes-sin-copyright.jpeg?fit=1920%2C1080&ssl=1'
  //img.src = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkvBlnlvXRya5H-XAisCKUmib-zKq1w4IpJA&usqp=CAU'

  img.classList.add('camp-block-img')
  img.alt = _block.name
  text.classList.add('block-name')
  text.innerText = _block.name

  block.appendChild(img)
  block.appendChild(text)
  container.appendChild(block)
  body.appendChild(container)
}